import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';
import TimeframePicker from '@components/TimeframePicker';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 'calc(100% - 32px)',
        height: 'calc(var(--100vh) - 32px)',
    },
    '& .modal-base-content': {
        display: 'grid',
        gridTemplateColumns: '50% 50%',
        padding: 0,
        '@media (max-width: 768px)': {
            gridTemplateColumns: '100%',
        },
    },
});

export const FormWrapper = styled('div')({
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    gap: 20,
    '@media (max-width: 768px)': {
        overflowY: 'initial',
        overflowX: 'initial',
    },
});

export const PreviewWrapper = styled('div')({
    backgroundColor: '#f2f2f2',
    overflowY: 'auto',
    padding: '24px 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    '@media (max-width: 768px)': {
        overflowY: 'initial',
    },
    '@media (max-width: 420px)': {
        padding: '24px 16px',
    },
});

export const TwoColumnRow = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    gap: 20,
    '@media (max-width: 768px)': {
        gridTemplateColumns: 'minmax(0, 1fr)',
    },
});

export const StyledTimeframePicker = styled(TimeframePicker)({
    '& .react-datepicker': {
        display: 'flex',
    },
});
